
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RoleInterface } from '@/services/Roles/Interfaces';
import RoleRepository from '@/services/Roles';

@Component({
  inject: [
    'rolesRepository',
  ],
})
export default class DeleteRoleDialog extends Vue {
  private readonly rolesRepository!: RoleRepository;

  @Prop() private readonly role!: RoleInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete ${this.role.name}?`;
  }

  private async deleteRole(): Promise<void> {
    try {
      await this.rolesRepository.deleteRole(this.role.id);
      this.$successDialog.show(`Role ${this.role.name} has been deleted.`);
      this.$emit('deleted-role', this.role.id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
